<div class="discover-card-badge flex items-center" [ngClass]="state">
  <p class="discover-card-badge_text">
    <span>{{ state === EDiscoverCardState.New ? '✨' : '🚀' }}</span>
    {{ state === EDiscoverCardState.New ? 'New' : 'Coming soon' }}
  </p>
</div>
